"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteStackService = void 0;
var inversify_1 = require("inversify");
var types_1 = require("../types");
var route_1 = require("../constants/route");
var IRouteStackService_1 = require("./IRouteStackService");
var RouteStackService = /** @class */ (function () {
    function RouteStackService() {
    }
    RouteStackService.prototype.persistent = function (routes) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (routes.length > 10) {
                            routes = routes.slice(routes.length - 10, routes.length);
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.storageService.setItem(route_1.ROUTES_INFO_KEY, JSON.stringify(routes))];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    RouteStackService.prototype.generateRouteInfo = function (param) {
        var _a, _b;
        var _c = param || {}, base = _c.base, extra = _c.extra, current = _c.current;
        var derivedFromCurrent;
        if (current) {
            derivedFromCurrent = {
                screenOrder: current.screenOrder + 1,
                screenReferrer: current.uri,
                screenReferrerOrder: current.screenOrder,
                screenReferrerNum: (_a = current.screenNum) !== null && _a !== void 0 ? _a : -1,
                saScreenReferrerNum: (_b = current.saScreenNum) !== null && _b !== void 0 ? _b : "-1",
            };
        }
        return __assign(__assign(__assign(__assign(__assign({ uri: window.location.href }, base), { screenOrder: 1, screenReferrer: "", screenReferrerOrder: 0, screenReferrerNum: -1, saScreenReferrerNum: "" }), derivedFromCurrent), extra), { createTime: Date.now(), isLeaveComplete: false });
    };
    RouteStackService.prototype.maybeAddCurrent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var routes, len, last;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRoutes()];
                    case 1:
                        routes = _a.sent();
                        len = routes.length;
                        last = routes[routes.length - 1];
                        if (!(!len || (len && (last.uri !== window.location.href || last.isLeaveComplete)))) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.addCurrent()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RouteStackService.prototype.addCurrent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var current, newRoute;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCurrent()];
                    case 1:
                        current = _a.sent();
                        // 这里再判断一次最新的路由与当前路由不同，因为 setPageConfig 可能会增加最新的路由信息，防止重复增加
                        if ((current === null || current === void 0 ? void 0 : current.uri) === window.location.href && !(current === null || current === void 0 ? void 0 : current.isLeaveComplete)) {
                            return [2 /*return*/];
                        }
                        newRoute = this.generateRouteInfo();
                        if ((current === null || current === void 0 ? void 0 : current.uri) !== window.location.href) {
                            newRoute = this.generateRouteInfo({
                                current: current,
                            });
                        }
                        return [4 /*yield*/, this.add(newRoute)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RouteStackService.prototype.findByUri = function (uri) {
        return __awaiter(this, void 0, void 0, function () {
            var routes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRoutes()];
                    case 1:
                        routes = _a.sent();
                        if (routes) {
                            return [2 /*return*/, routes.find(function (route) { return route.uri === uri; })];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    RouteStackService.prototype.setInitialRoutes = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.maybeAddCurrent()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RouteStackService.prototype.init = function (storePrefix) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.storageService.init({
                            name: storePrefix,
                            storeName: route_1.ROUTES_STORE_NAME,
                        });
                        return [4 /*yield*/, this.setInitialRoutes()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     *
     * @param type 路由类型
     */
    RouteStackService.prototype.addByType = function (type) {
        if (type === void 0) { type = IRouteStackService_1.RouteType.Change; }
        return __awaiter(this, void 0, void 0, function () {
            var current, route, newRoute, route;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCurrent()];
                    case 1:
                        current = _a.sent();
                        // 路由已存在时
                        if ((current === null || current === void 0 ? void 0 : current.uri) === window.location.href) {
                            return [2 /*return*/];
                        }
                        if (!(current && type === IRouteStackService_1.RouteType.Expired)) return [3 /*break*/, 4];
                        route = this.generateRouteInfo({
                            base: current,
                            extra: {
                                // screenOrder 都从 1 开始
                                screenOrder: 1,
                            },
                        });
                        return [4 /*yield*/, this.clear()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.add(route)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 4:
                        newRoute = this.generateRouteInfo();
                        if (!(current === null || current === void 0 ? void 0 : current.isLeaveComplete)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.findByUri(window.location.href)];
                    case 5:
                        route = _a.sent();
                        // 默认是多 tab 切换，继承之前的路由信息，并增加
                        newRoute = this.generateRouteInfo({
                            base: route,
                            extra: {
                                uri: window.location.href,
                                screenReferrerNum: (current === null || current === void 0 ? void 0 : current.screenReferrerNum) || -1,
                            },
                            current: current,
                        });
                        if (type !== IRouteStackService_1.RouteType.MultiTab) {
                            // 不是 tab 切换，则增加新的路由信息
                            newRoute = this.generateRouteInfo({
                                current: current,
                            });
                        }
                        _a.label = 6;
                    case 6: return [4 /*yield*/, this.add(newRoute)];
                    case 7:
                        _a.sent();
                        _a.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    RouteStackService.prototype.add = function (route) {
        return __awaiter(this, void 0, void 0, function () {
            var routes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRoutes()];
                    case 1:
                        routes = _a.sent();
                        routes.push(route);
                        return [4 /*yield*/, this.persistent(routes)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RouteStackService.prototype.updateCurrent = function (route) {
        return __awaiter(this, void 0, void 0, function () {
            var current, newRoute, routes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCurrent()];
                    case 1:
                        current = _a.sent();
                        newRoute = __assign(__assign({}, current), route);
                        return [4 /*yield*/, this.getRoutes()];
                    case 2:
                        routes = _a.sent();
                        routes[routes.length - 1] = newRoute;
                        return [4 /*yield*/, this.persistent(routes)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RouteStackService.prototype.updateByIndex = function (route, index) {
        return __awaiter(this, void 0, void 0, function () {
            var routes, r, newRoute;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRoutes()];
                    case 1:
                        routes = _a.sent();
                        if (index >= routes.length) {
                            return [2 /*return*/];
                        }
                        r = this.getByIndex(index);
                        newRoute = __assign(__assign({}, r), route);
                        routes[index] = newRoute;
                        return [4 /*yield*/, this.persistent(routes)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RouteStackService.prototype.getRoutes = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.storageService.getItem(route_1.ROUTES_INFO_KEY)];
                    case 1: return [2 /*return*/, (_a.sent()) || []];
                }
            });
        });
    };
    RouteStackService.prototype.getCurrent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var routes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRoutes()];
                    case 1:
                        routes = _a.sent();
                        return [2 /*return*/, routes[routes.length - 1]];
                }
            });
        });
    };
    RouteStackService.prototype.getByIndex = function (index) {
        return __awaiter(this, void 0, void 0, function () {
            var routes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRoutes()];
                    case 1:
                        routes = _a.sent();
                        if (index >= routes.length) {
                            return [2 /*return*/];
                        }
                        return [2 /*return*/, routes[index]];
                }
            });
        });
    };
    /**
     * 页面离开
     */
    RouteStackService.prototype.leave = function () {
        return __awaiter(this, void 0, void 0, function () {
            var current;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCurrent()];
                    case 1:
                        current = _a.sent();
                        if (!(current && !current.isLeaveComplete)) return [3 /*break*/, 3];
                        current.isLeaveComplete = true;
                        return [4 /*yield*/, this.updateCurrent(current)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RouteStackService.prototype.clear = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.storageService.clear()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        (0, inversify_1.inject)(types_1.TYPES.IStorageService),
        __metadata("design:type", Object)
    ], RouteStackService.prototype, "storageService", void 0);
    RouteStackService = __decorate([
        (0, inversify_1.injectable)()
    ], RouteStackService);
    return RouteStackService;
}());
exports.RouteStackService = RouteStackService;
